import {
    IProps,
} from './types';

import React, {
    FC,
} from 'react';

import {
    formatValue,
} from './helpers/format-value';

import {
    StringInput,
} from '..';

const NumberInput: FC<IProps> = (props) => {
    const onChangeValue = (value: string) => {
        if (!value) {
            props.onChangeValue(null);

            return;
        }
        if (!/\d+/.test(value)) {
            return;
        }

        props.onChangeValue(value);
    };

    return (
        <StringInput
            {...props}
            value={formatValue(props.value)}
            onChangeValue={onChangeValue}
        />
    );
};

export default NumberInput;
